var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import { Button, Icon, Input } from 'elements';
import PropTypes from 'prop-types';
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: ''
        };
        _this.handleChange = function (value) {
            _this.setState({ value: value });
            _this.props.onChange(value);
        };
        return _this;
    }
    SearchInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, onChange = _a.onChange, props = __rest(_a, ["onChange"]);
        var value = this.state.value;
        return (React.createElement(Wrapper, __assign({}, props),
            React.createElement(Icon, { name: "search" }),
            React.createElement(StyledInput, { type: "text", value: value, onChange: function (event) { return _this.handleChange(event.target.value); }, underline: props.underline || false }),
            React.createElement(Button, { onClick: function () { return _this.handleChange(''); } },
                React.createElement(Icon, { name: "del" }))));
    };
    return SearchInput;
}(Component));
export default SearchInput;
var Wrapper = cxs('div')({
    display: 'flex'
});
var StyledInput = cxs(Input)({
    flex: 1
});
StyledInput.propTypes = {
    underline: PropTypes.bool
};



//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput.tsx
// module id = 1043
// module chunks = 0